import React from 'react';
import { Button, Card } from 'antd';

export default function OrderCustomerCard(props) {
    const { order, onOpenChat } = props;
    const customer = order.customer || {};

    return (
        <Card title="Khách hàng">
            <div><strong>Tên:</strong> {customer.name || ''}</div>
            <div><strong>SĐT:</strong> {customer.phone || ''}</div>
            <div><strong>Địa chỉ:</strong> {customer.address_line || ''}</div>
            <Button style={{ marginTop: 12 }} onClick={onOpenChat}>Mở contact/chat</Button>
        </Card>
    );
}
